import {ReactNode, createContext, useContext} from "react";
import {useAuth0} from "@auth0/auth0-react";
import axios, { AxiosInstance } from "axios";

export const axiosContext = createContext<ContextValue>(undefined);
export const useAxios = () => useContext(axiosContext);

export type ProviderValue = AxiosInstance
export type DefaultValue = undefined
export type ContextValue = DefaultValue | ProviderValue
export type Props = {
    children: ReactNode
   };

export const AxiosProvider = ({children} : Props) => { 
  let token;
  const {getAccessTokenSilently} = useAuth0();
  const axiosInstance = axios.create({ 
    baseURL: process.env.REACT_APP_AXIOS_URL,
  });

  axiosInstance.interceptors.request.use(async (config) => {
    token = await getAccessTokenSilently();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  return <axiosContext.Provider value={axiosInstance}>{children}</axiosContext.Provider>;
};